import { utcToZonedTime } from 'date-fns-tz';

export const formatWithTimezone = (
  date: Date,
  timezone: string,
  callback: (date: Date) => string,
) => callback(utcToZonedTime(date, timezone));
